import React from 'react';

import { UploaderConsumer } from '../UploaderContext';





function withAssetSelector(WrappedComponent) {
  return (props) => {
    const { assetId } = props;

    return (
      <UploaderConsumer>
        {({ assetsMap }) =>
        <WrappedComponent
          asset={assetId ? assetsMap.get(assetId) : void 0}
          {...props} />}


      </UploaderConsumer>);

  };
}

export default withAssetSelector;